import React, { useEffect, useState } from "react";
import tmsRouteMap from "../../../../constants/tms-route.map";
import TmsTabsLayout from "../../../../components/tms-customs/tms-tabs-layout";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import TmsReportAnnadanamReport from "./tms-report-annadanam-report";
const TmsReportAnnadanam = ({ router }) => {
  const [active, setActive] = useState("Users");

  useEffect(() => {
    let location = router?.location?.pathname;
    if (location === tmsRouteMap.reports_annadanam) {
      setActive("Annadanam Report");
      return;
    } else if (
      location.includes(tmsRouteMap.reports_darshanam_summary_report)
    ) {
      setActive("Summary Report");
    }
  }, [router?.location?.pathname]);

  const components = [
    {
      name: "Annadanam Report",
      Element: <TmsReportAnnadanamReport />,
      key: "Annadanam Report",
      route: tmsRouteMap.reports_annadanam,
    },
  ];

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TmsTabsLayout
        components={components}
        active={active}
        setActive={setActive}
      />
    </div>
  );
};
export default withRouter(TmsReportAnnadanam);
